import { Container, Grid, IconButton, Typography } from '@material-ui/core'
import { ArrowBackIos, ArrowForwardIos } from '@material-ui/icons'
import Link from 'next/link'
import { useSelector } from 'react-redux'
import { Breadcumb } from './Breadcumb'

export const Navigation = () => {
  const offer = useSelector((state) => Object.values(state.application.included.job_offers)[0])
  const application = useSelector((state) => state.application)

  return (
    <Container>
      <Grid container>
        <Grid item xs={8}>
          <Breadcumb offer={offer} />
        </Grid>

        <Grid item xs={1}>
          <Typography align="right">
            {application.data.previous_application_hashid && (
              <Link href={`/entreprise/profile/application/${application.data.previous_application_hashid}`} prefetch={false}>
                <IconButton color="secondary">
                  <ArrowBackIos />
                </IconButton>
              </Link>
            )}
          </Typography>
        </Grid>

        <Grid item xs={2}>
          <Typography align="center" variant="h2" style={{ lineHeight: '45px' }}>
            {application.data.navigation_position}
            {'/'}
            {application.data.navigation_total}
          </Typography>
        </Grid>

        <Grid item xs={1}>
          {application.data.next_application_hashid && (
            <Link href={`/entreprise/profile/application/${application.data.next_application_hashid}`} prefetch={false}>
              <IconButton color="secondary">
                <ArrowForwardIos />
              </IconButton>
            </Link>
          )}
        </Grid>
      </Grid>
    </Container>
  )
}
